var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectedUnassignedDevicesRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-1058 -100)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1039 42C42.0976 42 42.9032 40.8748 42.9032 39.4868C42.9032 38.0988 42.0976 36.9736 41.1039 36.9736C40.1102 36.9736 39.3047 38.0988 39.3047 39.4868C39.3047 40.8748 40.1102 42 41.1039 42Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.026 42C33.8248 42 33.6235 41.9008 33.4696 41.7024C33.2329 41.4048 33.1855 41.0576 33.1855 40.8096C33.1855 40.5119 33.2566 40.2474 33.3986 40.0325L49.0355 15.3968C49.2012 15.1488 49.4379 15 49.6747 15C49.8759 15 50.0771 15.0992 50.231 15.2976C50.5861 15.7275 50.6216 16.4715 50.302 16.9841L34.6652 41.5866C34.4995 41.8512 34.2746 41.9835 34.026 41.9835V42Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1234 34.3447C45.0581 32.8567 43.7086 31.9142 42.2408 31.6001L41.0098 33.5346C42.4894 33.5015 43.969 34.2621 45.0936 35.8328C45.2238 36.0312 45.4132 36.1304 45.6144 36.1304C45.8156 36.1304 45.9932 36.0147 46.1352 35.8328V35.7997C46.4193 35.4029 46.4193 34.7746 46.1352 34.3778H46.1234V34.3447Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7468 31.1867H32.7705V31.2033C33.0546 31.5835 33.5044 31.567 33.7885 31.1867V31.1537C35.6469 28.5909 38.0025 27.2186 40.4054 27.0036L41.7075 24.9534C41.5063 24.9534 41.305 24.9038 41.092 24.9038C37.9551 24.9038 35.0077 26.5903 32.7823 29.6656H32.7705C32.7705 29.6656 32.7468 29.7152 32.7468 29.7317L32.6994 29.7979C32.4509 30.1947 32.4627 30.8064 32.735 31.1867H32.7468Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4486 29.698C48.3477 28.1769 47.0693 26.9864 45.6844 26.1763L44.6309 27.8297C46.0158 28.5241 47.3179 29.6319 48.4187 31.1861C48.5489 31.3845 48.7383 31.4837 48.9396 31.4837C49.1408 31.4837 49.3184 31.3679 49.4604 31.1861V31.153C49.7445 30.7562 49.7445 30.1279 49.4604 29.7311H49.4486V29.698Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7871 25.0862H52.7634V25.0697C51.5915 23.4493 50.3013 22.1266 48.9163 21.085L47.9102 22.6722C49.2951 23.6477 50.5853 24.9374 51.7454 26.5412C51.8874 26.7396 52.065 26.8388 52.2662 26.8388C52.4674 26.8388 52.6332 26.7396 52.7634 26.5577H52.7871C53.0711 26.1278 53.0711 25.483 52.7871 25.0862Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2882 20.886L45.3891 19.15C39.873 17.0832 33.7413 19.0508 29.4208 25.0857L29.2432 25.5156C29.1604 25.8793 29.2432 26.2761 29.4208 26.5407H29.4445V26.5572C29.7285 26.9375 30.1784 26.921 30.4624 26.5407C34.2148 21.3159 39.4587 19.4311 44.2882 20.886Z",
    fill: "#CA0000"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1027,
    y: -20,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2486 38.0002C27.4808 38.0002 28.4797 36.9584 28.4797 35.6732C28.4797 34.388 27.4808 33.3462 26.2486 33.3462C25.0165 33.3462 24.0176 34.388 24.0176 35.6732C24.0176 36.9584 25.0165 38.0002 26.2486 38.0002Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4718 38C17.2223 38 16.9728 37.9081 16.782 37.7244C16.4884 37.4489 16.4297 37.1274 16.4297 36.8977C16.4297 36.6222 16.5178 36.3772 16.6939 36.1782L36.0836 13.3674C36.2891 13.1378 36.5826 13 36.8762 13C37.1257 13 37.3752 13.0919 37.5661 13.2756C38.0064 13.6736 38.0504 14.3625 37.6541 14.8371L18.2644 37.6173C18.0589 37.8622 17.7801 37.9847 17.4718 37.9847V38Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4718 30.9119C31.1507 29.5341 29.4775 28.6615 27.6574 28.3706L26.1309 30.1618C27.9656 30.1312 29.8004 30.8354 31.1948 32.2898C31.3562 32.4735 31.5911 32.5653 31.8406 32.5653C32.0901 32.5653 32.3103 32.4582 32.4864 32.2898V32.2592C32.8387 31.8917 32.8387 31.31 32.4864 30.9426H32.4718V30.9119Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8868 27.9879H15.9162V28.0032C16.2684 28.3553 16.8262 28.34 17.1785 27.9879V27.9573C19.4829 25.5844 22.4038 24.3137 25.3835 24.1147L26.9981 22.2163C26.7485 22.2163 26.499 22.1704 26.2348 22.1704C22.3451 22.1704 18.6903 23.732 15.9308 26.5795H15.9162C15.9162 26.5795 15.8868 26.6254 15.8868 26.6407L15.8281 26.7019C15.5199 27.0694 15.5345 27.6358 15.8721 27.9879H15.8868Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.597 26.6095C35.2319 25.2011 33.6467 24.0988 31.9294 23.3486L30.623 24.8796C32.3404 25.5225 33.955 26.5483 35.32 27.9873C35.4815 28.171 35.7163 28.2629 35.9659 28.2629C36.2154 28.2629 36.4355 28.1557 36.6117 27.9873V27.9567C36.964 27.5893 36.964 27.0075 36.6117 26.6401H36.597V26.6095Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7368 22.3396H40.7074V22.3243C39.2543 20.824 37.6544 19.5992 35.9371 18.6348L34.6895 20.1045C36.4068 21.0077 38.0067 22.2018 39.4451 23.6868C39.6213 23.8705 39.8414 23.9624 40.091 23.9624C40.3405 23.9624 40.546 23.8705 40.7074 23.7021H40.7368C41.0891 23.3041 41.0891 22.707 40.7368 22.3396V22.3396Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1978 18.4501L31.5628 16.8427C24.7229 14.929 17.1196 16.7508 11.7622 22.3387L11.542 22.7367C11.4392 23.0735 11.542 23.4409 11.7622 23.6859H11.7915V23.7012C12.1438 24.0533 12.7015 24.038 13.0538 23.6859C17.7068 18.8482 24.2091 17.1029 30.1978 18.4501V18.4501Z",
    fill: "#CA0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -1029,
    y: -20,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-1058 -100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white",
    transform: "translate(28 15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 25,
    fill: "white",
    transform: "translate(10 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedUnassignedDevicesRed);
export default __webpack_public_path__ + "static/media/disconnected-unassigned-devices-red.7167c8797738150f622ce26331893ddf.svg";
export { ForwardRef as ReactComponent };